<template>
  <div>
    <b-container>
      <b-row align-h="center" align-v="center">
        <b-col cols="12" class="col-lg-6">
          <div v-show="error" class="alert alert-danger animated fadeIn">
            The email or password you’ve entered is incorrect.
            <a href="/recover">Forgot Password?</a>
          </div>
          <img
            src="~/static/dropsIcon.png"
            class="d-block mx-auto w-25"
            alt="Drops"
          >
          <h1 id="welcome" class="text-center">
            DROPS
          </h1>
          <b-button
            v-show="showSocialLogin"
            block
            variant="success"
            @click="loginSpotify"
          >
            <span>
              <font-awesome-icon :icon="['fab', 'spotify']" />
              Login via Spotify</span>
          </b-button>
          <b-button
            v-show="showSocialLogin"
            block
            variant="dark"
            @click="loginSketchfab"
          >
            <span>
              <!-- <font-awesome-icon :icon="['fab', 'spotify']" /> -->
              Login via Sketchfab</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row align-h="center" class="mt-4">
        <b-col cols="12" class="col-lg-6">
          <b-form @submit.prevent="submitForm(userInfo, confirmPassword)">
            <b-form-group
              v-if="isRegister"
              id="name"
              label="Full Name:"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="userInfo.name"
                type="text"
                name="name"
                required
              />
            </b-form-group>
            <b-form-group id="user-email" label="Email:" label-for="email">
              <b-form-input
                id="email"
                v-model="userInfo.email"
                type="email"
                name="email"
                required
              />
            </b-form-group>
            <b-form-group
              v-if="isRegister"
              id="username"
              label="Username:"
              label-for="username"
            >
              <b-form-input
                id="username"
                v-model="userInfo.username"
                type="text"
                name="username"
                required
              />
            </b-form-group>
            <b-form-group id="password" label="Password:" label-for="password">
              <b-form-input
                id="password"
                v-model="userInfo.password"
                type="password"
                required
              />
            </b-form-group>
            <b-form-group
              v-if="isRegister"
              id="confirm-password"
              label="Confirm Password:"
              label-for="confirm-password"
            >
              <b-form-input
                id="confirm-password"
                v-model="confirmPassword"
                type="password"
              />
            </b-form-group>
            <b-form-group>
              <b-form-checkbox
                v-if="isRegister"
                id="checkbox-link"
                v-model="userInfo.mailingList"
                name="checkbox-link"
                class="my-3"
              >
                Sign up to receive the Drops newsletter
              </b-form-checkbox>
            </b-form-group>
            <b-button type="submit" block variant="dark">
              {{
                buttonText
              }}
            </b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['submitForm', 'buttonText', 'isRegister'],
  data () {
    return {
      showSocialLogin: false, // hiding for private-beta
      error: false,
      loading: false,
      userInfo: {
        name: '',
        email: '',
        username: '',
        password: '',
        mailingList: false
      },
      confirmPassword: ''
    }
  },
  methods: {
    async loginSpotify () {
      try {
        debugger
        const response = await this.$auth.loginWith('spotify')
        // console.log(response)
        this.$auth.setUser(response.data.user)
      } catch (err) {
        // console.log(err)
      }
    },
    async loginSketchfab () {
      try {
        await this.$axios.get('auth/sketchfab/authorize')
        // const response = await this.$auth.loginWith('sketchfab', {
        //   params: { another_post_key: 'value' }
        // })
        // console.log(response)
        // this.$auth.setUser(response.data.user)
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>
/* #welcome {
  font-family: 'Raleway';
} */
</style>
